<template>
  <div :style="maxHeight" @mousewheel="getMaxHeight" style="overflow: hidden;">
  <el-button type="primary">{{ $t('makeSchedule.tzProducePage.wujianSelect') }}</el-button>
  <el-select v-model="wuJianId" style="width: 200px;margin-left: 10px" clearable @change="renderAllEcharts" :placeholder="$t('makeSchedule.tzProducePage.wujianName')" class="wujian_select_size">
    <el-option
        v-for="item in wuJianNames"
        :key="item.value"
        :label="item.label"
        :value="item.value">
    </el-option>
  </el-select>
  <el-row style="width: 100%;height: 45%;margin-top: 10px">
    <div style="width: 50%;height: 100%;border-right: 8px solid whitesmoke;border-bottom: 8px solid whitesmoke;">
      <el-form :model="productionWeight" label-width="10px">
        <el-row>
          <el-form-item>
            <el-date-picker v-model="productionWeight.day" @change="getProductionWeight" format="YYYY 年 M 月"
                            value-format="YYYY-M-1" type="month" placeholder="选择月份" style="width: 140px;" :clearable="false"/>
          </el-form-item>
        </el-row>
      </el-form>
      <div class="divSize" v-loading="productionWeightOutputLoading" element-loading-text="数据加载中"
           style="width: 100%;height: 90%;" id="productionWeightOutput"/>
    </div>

    <div style="width: 50%;height: 100%;border-bottom: 8px solid whitesmoke;">
      <el-form :model="productionArea" label-width="10px">
        <el-row>
          <el-form-item>
            <el-date-picker v-model="productionArea.day" @change="getProductionArea" format="YYYY 年 M 月" value-format="YYYY-M-1"
                            type="month" placeholder="选择月份" style="width: 140px;" :clearable="false"/>
          </el-form-item>
        </el-row>
      </el-form>
      <div class="divSize" v-loading="productionAreaOutputLoading" element-loading-text="数据加载中"
           style="width: 100%;height: 90%;" id="productionAreaOutput"/>
    </div>
  </el-row>

  <el-row style="width: 100%;height: 50%;">
    <div style="width:50%;height:100%;border-right: 8px solid whitesmoke;border-bottom: 8px solid whitesmoke;">
      <el-form label-width="10px">
        <el-row>
          <el-form-item>
            <el-date-picker v-model="qclActualData.day" @change="getQclProduceActual" format="YYYY 年 M 月"
                            value-format="YYYY-M-1" type="month" placeholder="选择月份" style="width: 140px;" :clearable="false"/>
          </el-form-item>
        </el-row>
      </el-form>

      <!--  生产实绩-->
      <div class="divSize" v-loading="qclActualOutputLoading" element-loading-text="数据加载中"
           style="width: 100%;height:90%;" id="qclActualOutput"/>
    </div>

    <div style="width:50%;height:100%;border-bottom: 8px solid whitesmoke;">
      <el-form label-width="10px">
        <el-row>
          <el-form-item>
            <el-date-picker v-model="ptActualData.day" @change="getPtProduceActual" format="YYYY 年 M 月"
                            value-format="YYYY-M-1" type="month" placeholder="选择月份" style="width: 140px;" :clearable="false"/>
          </el-form-item>
        </el-row>
      </el-form>

      <!--  生产实绩-->
      <div class="divSize" v-loading="ptActualOutputLoading" element-loading-text="数据加载中"
           style="width: 100%;height:90%;" id="ptActualOutput"/>
    </div>
  </el-row>
</div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "MfgTuZhuangProduce",
  data() {
    return {
      maxHeight:'',
      wuJianId:'',
      wuJianNames: [],
      productionWeight: {
        day: this.getDateFormat(),
        wuJianId: ''
      },
      productionArea: {
        day: this.getDateFormat(),
        wuJianId: ''
      },
      qclActualData: {
        day: this.getDateFormat(),
        wuJianId: '',
        tableName: 'mfg_pretreatment_plan_actual'
      },
     ptActualData: {
        day: this.getDateFormat(),
        wuJianId: '',
        tableName: 'mfg_spray_plan_actual'
      },
      //涂装重量（KG）
      productionWeightOutput: {
        title: [
          {
            text: this.$t('makeSchedule.tzProducePage.tzProduction'),
            left: '50%',
            textAlign: 'center'
          },],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          bottom: '20',
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name:'重量(kg)',
            axisLabel: {
              formatter: function (value){
                return Math.ceil(value).toLocaleString()
              }
            }
          },
        ],
        series: [
          {
            name: this.$t('makeSchedule.tzProducePage.qcl'),
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '喷涂',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
        ]
      },
      productionWeightOutputLoading: false,
      // 涂装前面积
      productionAreaOutput: {
        title: [
          {
            text: this.$t('makeSchedule.tzProducePage.tzArea'),
            left: '50%',
            textAlign: 'center'
          },],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          bottom: '20',
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: this.$t('makeSchedule.tzProducePage.area'),
            axisLabel: {
              formatter: function (value){
                return Math.ceil(value).toLocaleString()
              }
            }
          },
        ],
        series: [
          {
            name: this.$t('makeSchedule.tzProducePage.qcl'),
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '喷涂',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
        ]
      },
      productionAreaOutputLoading: false,
      //物件前处理日生产生产实绩
      qclActualOutput: {
        title: [
          {
            text: this.$t('makeSchedule.tzProducePage.tzQclAchievements'),
            left: '50%',
            textAlign: 'center'
          },],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          bottom: '30',
          data: [this.$t('makeSchedule.tzProducePage.plan'),this.$t('makeSchedule.tzProducePage.achievements'),this.$t('makeSchedule.tzProducePage.totalPlan'),this.$t('makeSchedule.tzProducePage.totalAchievements')]
        },
        grid: {
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            axisTick: {
              show: false
            },
            data: []
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: this.$t('makeSchedule.tzProducePage.area'),
            axisLabel: {
              formatter: function (value){
                return Math.ceil(value).toLocaleString()
              }
            }
          },
          {
            type: 'value',
            name: this.$t('makeSchedule.tzProducePage.totalArea'),
            axisLabel: {
              formatter: function (value){
                return Math.ceil(value).toLocaleString()
              }
            }
          }
        ],
        series: [
          {
            name: this.$t('makeSchedule.tzProducePage.plan'),
            type: 'bar',
            label: {
              position: 'inside'
            },
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: this.$t('makeSchedule.tzProducePage.achievements'),
            type: 'bar',
            label: {},
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: this.$t('makeSchedule.tzProducePage.totalPlan'),
            type: 'line',
            color:'#fac858',
            label: {},
            yAxisIndex: 1,
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: this.$t('makeSchedule.tzProducePage.totalAchievements'),
            type: 'line',
            color:'#ee6666',
            yAxisIndex: 1,
            label: {},
            emphasis: {
              focus: 'series'
            },
            data: []
          }
        ]
      },
      qclActualOutputLoading: false,
      //物件喷涂日生产生产实绩
      ptActualOutput: {
        title: [
          {
            text: this.$t('makeSchedule.tzProducePage.tzAchievements'),
            left: '50%',
            textAlign: 'center'
          },],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          bottom: '30',
          data: [this.$t('makeSchedule.tzProducePage.plan'),this.$t('makeSchedule.tzProducePage.achievements'),this.$t('makeSchedule.tzProducePage.totalPlan'),this.$t('makeSchedule.tzProducePage.totalAchievements')]
        },
        grid: {
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            axisTick: {
              show: false
            },
            data: []
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: this.$t('makeSchedule.tzProducePage.area'),
            axisLabel: {
              formatter: function (value){
                return Math.ceil(value).toLocaleString()
              }
            }
          },
          {
            type: 'value',
            name: this.$t('makeSchedule.tzProducePage.totalArea'),
            axisLabel: {
              formatter: function (value){
                return Math.ceil(value).toLocaleString()
              }
            }
          }
        ],
        series: [
          {
            name: this.$t('makeSchedule.tzProducePage.plan'),
            type: 'bar',
            label: {
              position: 'inside'
            },
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: this.$t('makeSchedule.tzProducePage.achievements'),
            type: 'bar',
            label: {},
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: this.$t('makeSchedule.tzProducePage.totalPlan'),
            type: 'line',
            color:'#fac858',
            label: {},
            yAxisIndex: 1,
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: this.$t('makeSchedule.tzProducePage.totalAchievements'),
            type: 'line',
            color:'#ee6666',
            yAxisIndex: 1,
            label: {},
            emphasis: {
              focus: 'series'
            },
            data: []
          }
        ]
      },
      ptActualOutputLoading: false
    }
  },
  methods: {
    getMaxHeight() {
      let pageHeight = document.body.scrollHeight -140;
      this.maxHeight = "height: "+pageHeight+"px;";
    },
    getDateFormat() {
      let month = new Date().getMonth() + 1
      return new Date().getUTCFullYear().toString() + "-" + month.toString() + "-1"
    },
    renderEcharts(id, option) {
      if (document.getElementById(id)) {
        echarts.init(document.getElementById(id)).dispose();
        let chart = echarts.init(document.getElementById(id));
        chart.setOption(option)
      }
    },
    async getWuJianInFo() {
      let {data: res} = await this.$axios.post('mfg/wujianPlan/getWujianName');
      if (res.code !== 0) {
        this.$message.error('获取【物件信息】失败')
        return;
      }
      this.wuJianNames = res.data;
    },
    // 涂装前处理产量（KG）
    async getProductionWeight() {
      if (!this.productionWeight.day) {
        this.productionWeight.day = this.getDateFormat()
      }
      this.productionWeight.wuJianId = this.wuJianId
      this.productionWeightOutputLoading = true
      let {data: res} = await this.$axios.post('mfg/tuzhuangProduce/getTzWeight', this.productionWeight);
      if (res.code !== 0) {
        this.$message.error(res.message)
      } else {
        this.productionWeightOutput.xAxis[0].data = res.data.xAxis
        this.productionWeightOutput.series[0].data = res.data.pretreatmentList
        this.productionWeightOutput.series[1].data = res.data.sprayList
        let a = this.$common.getDivisor(Math.max(...res.data.pretreatmentList))
        this.productionWeightOutput.yAxis[0].max = Math.ceil(Math.max(...res.data.pretreatmentList) / a) * (a + 3)
        this.productionWeightOutput.yAxis[0].interval = Math.round(this.productionWeightOutput.yAxis[0].max / 5 * 100) / 100
      }
      this.renderEcharts('productionWeightOutput', this.productionWeightOutput)

      this.productionWeightOutputLoading = false
    },

    // 涂装面积（m）
    async getProductionArea() {
      if (!this.productionArea.day) {
        this.productionArea.day = this.getDateFormat()
      }
      this.productionArea.wuJianId = this.wuJianId
      this.productionAreaOutputLoading = true
      let {data: res} = await this.$axios.post('mfg/tuzhuangProduce/getTzArea', this.productionArea);
      if (res.code !== 0) {
        this.$message.error(res.message)
      } else {
        this.productionAreaOutput.xAxis[0].data = res.data.xAxis
        this.productionAreaOutput.series[0].data = res.data.pretreatmentList
        this.productionAreaOutput.series[1].data = res.data.sprayList
        let a = this.$common.getDivisor(Math.max(...res.data.pretreatmentList))
        this.productionAreaOutput.yAxis[0].max = Math.ceil(Math.max(...res.data.pretreatmentList) / a) * (a + 3)
        this.productionAreaOutput.yAxis[0].interval = Math.round(this.productionAreaOutput.yAxis[0].max / 5 * 100) / 100
      }
      this.renderEcharts('productionAreaOutput', this.productionAreaOutput)

      this.productionAreaOutputLoading = false
    },

    //前处理生产实绩
    async getQclProduceActual() {

      if (!this.qclActualData.day) {
        this.qclActualData.day = this.getDateFormat()
      }
      this.qclActualData.wuJianId = this.wuJianId
      this.qclActualOutputLoading = true
      let {data: res} = await this.$axios.post('mfg/tuzhuangProduce/getProduceActual', this.qclActualData);
      if (res.code !== 0) {
        this.$message.error(res.message)
      } else {
        this.qclActualOutput.xAxis[0].data = res.data.xAxis
        this.qclActualOutput.series[0].data = res.data.areaPlanList
        this.qclActualOutput.series[1].data = res.data.areaActualList
        this.qclActualOutput.series[2].data = res.data.accumulateAreaPlanList
        this.qclActualOutput.series[3].data = res.data.accumulateAreaActualList

        let maxA = this.$common.getMaxValue(res.data.areaPlanList,res.data.areaActualList)
        let maxB = this.$common.getMaxValue(res.data.accumulateAreaPlanList,res.data.accumulateAreaActualList)

        this.qclActualOutput.yAxis[0].max = Math.ceil(maxA/5)*6
        this.qclActualOutput.yAxis[0].interval = Math.round(this.qclActualOutput.yAxis[0].max / 5 * 100) / 100

        this.qclActualOutput.yAxis[1].max = Math.ceil(maxB/5)*6
        this.qclActualOutput.yAxis[1].interval = Math.round(this.qclActualOutput.yAxis[1].max / 5 * 100) / 100
      }
      this.renderEcharts('qclActualOutput', this.qclActualOutput)
      this.qclActualOutputLoading = false
    },

    //喷涂生产实绩
    async getPtProduceActual() {

      if (!this.ptActualData.day) {
        this.ptActualData.day = this.getDateFormat()
      }
      this.ptActualData.wuJianId = this.wuJianId
      this.ptActualOutputLoading = true
      let {data: res} = await this.$axios.post('mfg/tuzhuangProduce/getProduceActual', this.ptActualData);
      console.log(res.data)
      if (res.code !== 0) {
        this.$message.error(res.message)
      } else {
        this.ptActualOutput.xAxis[0].data = res.data.xAxis
        this.ptActualOutput.series[0].data = res.data.areaPlanList
        this.ptActualOutput.series[1].data = res.data.areaActualList
        this.ptActualOutput.series[2].data = res.data.accumulateAreaPlanList
        this.ptActualOutput.series[3].data = res.data.accumulateAreaActualList

        let maxA = this.$common.getMaxValue(res.data.areaPlanList,res.data.areaActualList)
        let maxB = this.$common.getMaxValue(res.data.accumulateAreaPlanList,res.data.accumulateAreaActualList)

        this.ptActualOutput.yAxis[0].max = Math.ceil(maxA/5)*6
        this.ptActualOutput.yAxis[0].interval = Math.round(this.ptActualOutput.yAxis[0].max / 5 * 100) / 100

        this.ptActualOutput.yAxis[1].max = Math.ceil(maxB/5)*6
        this.ptActualOutput.yAxis[1].interval = Math.round(this.ptActualOutput.yAxis[1].max / 5 * 100) / 100
      }
      this.renderEcharts('ptActualOutput', this.ptActualOutput)
      this.ptActualOutputLoading = false
    },

    renderAllEcharts(){
      this.getProductionWeight()
      this.getProductionArea()
      this.getQclProduceActual()
      this.getPtProduceActual()
    },
  },
  mounted() {
    this.getProductionWeight()
    this.getProductionArea()
    this.getQclProduceActual()
    this.getPtProduceActual()
  },
  created() {
    this.getWuJianInFo()
    this.getMaxHeight()

  }
}
</script>

<style scoped>
.divSize {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

</style>